module.exports = __webpack_public_path__ + "img/empiricus-research-short-logo-preto.4d1c3c18.svg";